/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LearnerShell, { EmptyState } from "./learnerShell";
import LearnerCourseCard from "./learnerCourseCard";
import { learnerEnrolmentsApi } from "./_learnerActions";

const listOf = (data) =>
  Array.isArray(data) ? data : data?.list || data?.enrolments || [];

// My Courses — every enrolment (in progress + completed) with course populated.
const LearnerMyCourses = () => {
  const { t } = useTranslation();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await learnerEnrolmentsApi();
        if (res?.data?.status === 200) setRows(listOf(res?.data?.data));
        else setError(res?.data?.message || t("common.somethingWentWrong"));
      } catch (e) {
        setError(e?.response?.data?.message || t("common.somethingWentWrong"));
      }
      setLoading(false);
    })();
  }, []);

  return (
    <LearnerShell title={t("learner.lms.nav.myCourses", "My Courses")}>
      <h1 className="lms-portal-title">
        {t("learner.lms.nav.myCourses", "My Courses")}
      </h1>
      {loading && (
        <div className="lms-portal-loading">
          <i className="fas fa-circle-notch fa-spin mr-2"></i>
          {t("common.loading", "Loading…")}
        </div>
      )}
      {!loading && error && (
        <div className="lms-portal-error" role="alert">
          {error}
        </div>
      )}
      {!loading && !error && (
        <>
          {rows.length ? (
            <div className="lms-course-grid">
              {rows.map((r, i) => (
                <LearnerCourseCard row={r} key={r?._id || i} />
              ))}
            </div>
          ) : (
            <EmptyState
              icon="fa-book-open"
              text={t("learner.lms.dashboard.noEnrolled", "You're not enrolled in any courses yet — pick one below to get started.")}
            />
          )}
        </>
      )}
    </LearnerShell>
  );
};

export default LearnerMyCourses;
